// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  padding-bottom: 20px;
}

.normalDisplayLeft, .normalDisplayRight {
  width: 50%;
}

.normalDisplayLeft {
  padding-right: 5px;
}

.normalDisplayRight {
  padding-left: 5px;
}

table.aptitudeContainer {
  width: 100%;
}

table.aptitudeContainer tr td:first-child {
  width: 40%;
}

table.aptitudeContainer tr td:nth-child(2) {
  width: 58%;
}

table.talentContainer,
table.talentOrderedContainer {
  width: 100%;
}

table.talentContainer tr td {
  vertical-align: top;
}

table.talentContainer tr td:first-child {
  padding-right: 5px;
}

table.talentContainer tr td:last-child {
  padding-left: 5px;
}

.talentTitle {
  margin: 0;
  padding: 0 12px 0 0;
}

@media (max-width: 1235px) {
  .talents {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }
  .talents .tableOrderedContainer tr {
    display: flex;
    flex-direction: column;
  }
  .talents .tableOrderedContainer tr td {
    padding-left: 0 !important;
  }
  .talents .tableOrderedContainer tr td.paddingLeft12 {
    padding-left: 0 !important;
  }
}
@media (max-width: 696px) {
  .talents {
    flex-direction: column;
  }
}
.paddingLeft12 {
  padding-left: 12px !important;
}

.boldTitle {
  font-size: 16px;
  font-weight: normal;
  line-height: 1.4em;
  letter-spacing: 0.01em;
  margin-top: 15px;
  padding: 0 0 0.5em 0;
}

.bTAptitudes {
  padding: 0 0 0.35em 0;
}

/* Dropdown Button */
.dropbtn {
  text-align: right;
  padding: 5px;
  border: none;
  font-size: 127%;
}

.dropbtnSmall {
  width: 160px;
}

.dropbtnLarge {
  width: 225px;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
  margin-top: -2px;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #EDF2F5;
  min-width: 160px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 5px 6px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

div.surfInPage div {
  width: 100%;
  padding: 5px;
}

div.surfInPage div:hover {
  background-color: #DDD;
}

#upButton img {
  opacity: 0.4;
}

#upButton img:hover {
  opacity: 1;
}

.instructions p, .instructions ul li {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/web/people-report-talents/people-report-talents.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,UAAA;AAGJ;;AAAA;;EAEI,WAAA;AAGJ;;AAAA;EACI,mBAAA;AAGJ;;AAAA;EACI,kBAAA;AAGJ;;AADA;EACI,iBAAA;AAIJ;;AADA;EACI,SAAA;EACA,mBAAA;AAIJ;;AADA;EACI;IACI,aAAA;IACA,mBAAA;IACA,6BAAA;EAIN;EADU;IACI,aAAA;IACA,sBAAA;EAGd;EAFc;IACI,0BAAA;EAIlB;EAHkB;IACI,0BAAA;EAKtB;AACF;AAEA;EACI;IACI,sBAAA;EAAN;AACF;AAGA;EACI,6BAAA;AADJ;;AAIA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA,oBAAA;AACA;EACI,iBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;AADJ;;AAIA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0CAAA;EACA,UAAA;AADJ;;AAIA,8BAAA;AACA;EACI,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AADJ;;AAIA,4CAAA;AACA;EAA2B,sBAAA;AAA3B;;AAEA,oCAAA;AACA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":["h2 {\n    padding-bottom: 20px\n}\n.normalDisplayLeft, .normalDisplayRight {\n    width:50%;\n}\n\n.normalDisplayLeft {\n    padding-right: 5px;\n}\n\n.normalDisplayRight {\n    padding-left: 5px;\n}\n\ntable.aptitudeContainer {\n    width: 100%;\n}\n\ntable.aptitudeContainer tr td:first-child {\n    width: 40%\n}\ntable.aptitudeContainer tr td:nth-child(2) {\n    width: 58%;\n}\n\ntable.talentContainer,\ntable.talentOrderedContainer {\n    width: 100%;\n}\n\ntable.talentContainer tr td {\n    vertical-align: top;\n}\n\ntable.talentContainer tr td:first-child {\n    padding-right: 5px;\n}\ntable.talentContainer tr td:last-child {\n    padding-left: 5px;\n}\n\n.talentTitle {\n    margin:0;\n    padding: 0 12px 0 0;\n}\n\n@media (max-width: 1235px) {\n    .talents {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-evenly;\n\n        .tableOrderedContainer {\n            tr {\n                display: flex;\n                flex-direction: column;\n                td {\n                    padding-left: 0!important;\n                    &.paddingLeft12 {\n                        padding-left: 0 !important;\n                    }\n                }\n            }\n        }\n    }\n\n}\n@media (max-width: 696px) {\n    .talents {\n        flex-direction: column;\n    }\n}\n\n.paddingLeft12 {\n    padding-left: 12px !important;\n}\n\n.boldTitle {\n    font-size: 16px;\n    font-weight: normal;\n    line-height: 1.4em;\n    letter-spacing: 0.01em;\n    margin-top: 15px;\n    padding: 0 0 0.5em 0;\n}\n\n.bTAptitudes {\n    padding: 0 0 0.35em 0;\n}\n\n/* Dropdown Button */\n.dropbtn {\n    text-align: right;\n    padding: 5px;\n    border: none;\n    font-size: 127%;\n}\n\n.dropbtnSmall {\n    width: 160px\n}\n\n.dropbtnLarge {\n    width: 225px\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n    margin-top: -2px\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #EDF2F5;\n    min-width: 160px;\n    box-shadow: 0 3px 4px 0 rgba(0,0,0,0.2);\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n    color: black;\n    padding: 5px 6px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Change color of dropdown links on hover */\n.dropdown-content a:hover {background-color: #ddd}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\ndiv.surfInPage div {\n    width: 100%;\n    padding: 5px;\n}\n\ndiv.surfInPage div:hover {\n    background-color: #DDD;\n}\n\n#upButton img {\n    opacity: .4;\n}\n\n#upButton img:hover {\n    opacity: 1;\n}\n\n.instructions p, .instructions ul li {\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
